import { type VehicleInfo as VehicleInfoType } from '@/api/queryCatalog';
import { useMemo, useState } from 'react';
import { DetailCard, LayoutForm } from 'xui-pro';
import collapsedIcon from './assets/collapsed.png';
import styles from './index.module.less';

type VehicleInfoProps = {
  data?: VehicleInfoType;
  vin?: string;
};

const VehicleInfo = (props: VehicleInfoProps) => {
  const [collapsed, setCollapsed] = useState(true);
  const [formItems] = useState(() => {
    return [
      {
        label: 'VIN',
        type: 'input',
        name: 'vin',
        hidden: props.vin ? false : true
      },
      {
        label: '品牌车系车型',
        type: 'input',
        name: 'modelName'
      },
      {
        label: '车辆颜色',
        type: 'input',
        name: 'colorOut',
        hidden: props.vin ? false : true
      },
      {
        label: '内饰颜色',
        type: 'input',
        name: 'colorIn',
        hidden: props.vin ? false : true
      },
      {
        label: '车辆配置名称',
        type: 'input',
        name: 'skuName',
        hidden: props.vin ? false : true
      },
      {
        label: '下线日期',
        type: 'input',
        name: 'manufactureTime',
        hidden: props.vin ? false : true
      }
    ].filter(item => !item.hidden);
  });
  const data = useMemo(() => {
    return {
      ...props.data,
      modelName: `${props.data?.brandName}/${props.data?.seriesName}/${props.data?.modelName}`
    };
  }, [props.data]);
  return (
    <DetailCard
      title={'车辆信息'}
      style={{ paddingRight: '16px' }}
      action={
        <div className={styles['vehicle-collapsed']} onClick={() => setCollapsed(!collapsed)}>
          <span className={styles['text']}>{collapsed ? '展开' : '收起'}</span>
          <img
            src={collapsedIcon}
            className={`${styles['icon']} ${collapsed ? '' : styles['collapsed']}`}
            alt='empty'
          />
        </div>
      }
    >
      {!collapsed && (
        <LayoutForm
          formItems={formItems}
          initialValues={data}
          readonly={true}
          mode={'form'}
          span={24}
          emptyPlaceholder='-'
          hasEmptyPlaceholder={true}
          layout='vertical'
        />
      )}
    </DetailCard>
  );
};

export default VehicleInfo;
